import { render, staticRenderFns } from "./recallTest.vue?vue&type=template&id=1d007375&scoped=true&"
import script from "./recallTest.vue?vue&type=script&lang=js&"
export * from "./recallTest.vue?vue&type=script&lang=js&"
import style0 from "./recallTest.vue?vue&type=style&index=0&id=1d007375&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d007375",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d007375')) {
      api.createRecord('1d007375', component.options)
    } else {
      api.reload('1d007375', component.options)
    }
    module.hot.accept("./recallTest.vue?vue&type=template&id=1d007375&scoped=true&", function () {
      api.rerender('1d007375', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerService/recallTest.vue"
export default component.exports